export enum MeasurementSystemEnum {
    metric = "METRIC_SYSTEM",
    imperial = "IMPERIAL_SYSTEM"
}
